import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles({
  logo: {
    height: "16px",
    width: "16px",
  },
});
